import React, { useEffect, useState } from 'react';
import { Wallet, ArrowDownCircle, ArrowUpCircle, Loader2, Info } from 'lucide-react';
import { Link } from 'react-router-dom';
import { accountAPI } from '../services/api';
import { useT, i18n } from '../services/i18n';

const money = (v) => `${Number(v || 0).toFixed(2)} €`;
const TYPE = { credit: 'acc.txCredit', debit: 'acc.txDebit', order: 'acc.txOrder', refund: 'acc.txRefund' };

// Deposit account: store credit balance + movements
const WalletSection = () => {
  const { t } = useT();
  const [data, setData] = useState(null);
  useEffect(() => { accountAPI.wallet().then(setData).catch(() => setData({ balance: 0, transactions: [] })); }, []);
  if (!data) return <div className="flex justify-center py-10"><Loader2 className="animate-spin text-orange-500" /></div>;
  return (
    <div className="space-y-6" data-testid="wallet-section">
      <div className="bg-[#0e0e10] text-white rounded-xl p-6 flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-wide text-gray-400 flex items-center gap-2"><Wallet size={14} /> {t('acc.balance')}</p>
          <p className="text-4xl font-bold mt-1" data-testid="wallet-balance">{money(data.balance)}</p>
          <p className="text-xs text-gray-400 mt-1">{t('acc.walletUsage')}</p>
        </div>
        <Link to="/pieces" className="bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold px-4 py-2 rounded-md" data-testid="wallet-shop-link">Utiliser mon avoir</Link>
      </div>
      <p className="text-xs text-gray-600 bg-blue-50 border border-blue-100 rounded-lg px-3 py-2 flex items-center gap-2"><Info size={14} className="text-blue-500" /> {t('acc.walletIntro')}</p>
      <section className="bg-white rounded-xl shadow-sm overflow-hidden" data-testid="wallet-history">
        <h2 className="text-lg font-bold text-gray-900 px-6 pt-5 pb-3">{t('acc.history')}</h2>
        {data.transactions.length === 0 ? <p className="px-6 pb-6 text-sm text-gray-500" data-testid="wallet-empty">{t('acc.noTx')}</p> : (
          <div className="overflow-x-auto"><table className="w-full text-sm">
            <thead className="bg-gray-50 text-xs text-gray-500 uppercase"><tr><th className="px-6 py-2 text-left">Date</th><th className="px-6 py-2 text-left">Libellé</th><th className="px-6 py-2 text-right">Montant</th></tr></thead>
            <tbody className="divide-y">
              {data.transactions.map(tx => (
                <tr key={tx.id} data-testid={`wallet-tx-${tx.id}`}>
                  <td className="px-6 py-2 text-gray-600 whitespace-nowrap">{new Date(tx.created_at).toLocaleDateString(i18n.locale())}</td>
                  <td className="px-6 py-2"><p className="text-gray-900">{tx.label}</p><p className="text-xs text-gray-400">{TYPE[tx.type] ? t(TYPE[tx.type]) : tx.type}</p></td>
                  <td className={`px-6 py-2 text-right font-semibold whitespace-nowrap ${tx.amount >= 0 ? 'text-green-700' : 'text-red-600'}`}>{tx.amount >= 0 ? <ArrowDownCircle size={13} className="inline mr-1" /> : <ArrowUpCircle size={13} className="inline mr-1" />}{tx.amount >= 0 ? '+' : ''}{money(tx.amount)}</td>
                </tr>
              ))}
            </tbody>
          </table></div>
        )}
      </section>
    </div>
  );
};

export default WalletSection;
